module.exports = require('./helpers/bundle-url').getBundleURL('cQKSD') + "cash.bb37225b.png";